export const removeDuplicateAttachments = (attachments) => {
    const seen = new Set();
    return attachments.filter((att) => {
      const identifier = `${att.attachmentType?.id || ""}-${att.chapterNumber || ""}-${att.blockNumber || ""}-${att.version}`;
      if (seen.has(identifier)) {
        return false;
      } else {
        seen.add(identifier);
        return true;
      }
    });
  };
